import { render, staticRenderFns } from "./materialManagement.vue?vue&type=template&id=56f8a6cc&scoped=true"
import script from "./materialManagement.vue?vue&type=script&lang=js"
export * from "./materialManagement.vue?vue&type=script&lang=js"
import style0 from "./materialManagement.vue?vue&type=style&index=0&id=56f8a6cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f8a6cc",
  null
  
)

export default component.exports